import { Minus, Plus } from "lucide-react";

const STYLES = {
  in_stock: "bg-white/95 text-[#4f5d27]",
  low_stock: "bg-accent text-white",
  unavailable: "bg-stone-800/80 text-white",
  coming_soon: "bg-primary text-white",
};
const LABELS = { in_stock: "In stock", low_stock: "Low stock", unavailable: "Unavailable", coming_soon: "Coming soon" };

export const StockBadge = ({ status, qty, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-bold tracking-wide ${STYLES[status]}`}>
    {status === "low_stock" ? `Only ${qty} left` : LABELS[status]}
  </span>
);

export const QtyStepper = ({ qty, max, onChange, testId }) => (
  <div className="flex items-center rounded-full bg-primary text-white h-10" data-testid={testId}>
    <button onClick={() => onChange(qty - 1)} className="w-10 h-10 flex items-center justify-center active:scale-90 transition-transform" data-testid={`${testId}-dec`}>
      <Minus className="w-4 h-4" />
    </button>
    <span className="w-6 text-center font-bold text-sm" data-testid={`${testId}-qty`}>{qty}</span>
    <button onClick={() => onChange(qty + 1)} disabled={qty >= max} className="w-10 h-10 flex items-center justify-center disabled:opacity-40 active:scale-90 transition-transform" data-testid={`${testId}-inc`}>
      <Plus className="w-4 h-4" />
    </button>
  </div>
);
